import React, { useEffect, useRef, useState } from "react";
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { ApiService } from '../../containers/Services/apiservice';
import moment from "moment";
import { Link, useHistory } from 'react-router-dom';
import { Watch } from "react-loader-spinner";
import { Dropdown } from "react-bootstrap";
let apiServices = new ApiService();
const Holdings = () => {
  let history = useHistory();
  const didMountRef = useRef(true);
  const [HoldingsData, setHoldingdData] = useState([])
  const [GoalstoxHoldingsData, setGoalstoxHoldingsData] = useState([])
  const [headerData, setHeaderData] = useState({})
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [portfolioshow, setportfolioshow] = useState(1);
  const [goalstoxportfolio, setgoalstoxportfolio] = useState(0);
  const [goalstoxportfolioclass, setgoalstoxportfolioclass] = useState('panel holding-panel phbox active mg-b-15');
  const [totalportfolioclass, settotalportfolioclass] = useState('panel holding-panel phbox mg-b-15');
  // const [showdropdown, setshowdropdown] = useState('none');
  useEffect(() => {
    if (didMountRef.current) {
      getgoalstoxholdings();
      setSpinnerLoading(true);
      const dataString = {
      }
      apiServices.getpreviousholdingsdataPostRequest(dataString).then(res => {
        if (res.data.status == "success") {
          // console.log(res.data.headersData)
          setHoldingdData(res.data.data)
          setHeaderData(res.data.headersData)
          setSpinnerLoading(false);
        }
        else if (res.data.status == "error" && res.data.message == "Session expired") {
          localStorage.removeItem('AUTH_TOKEN');
          // alert(res.data.message)
          setSpinnerLoading(false)
          history.push("/login")
        }
        else {
          alert(res.data.message)
          setSpinnerLoading(false)
        }
      })
    }
    didMountRef.current = false;
  })
  const purchasedetail = (e) => {
  };
  const sipdetail = (e) => {
  };
  const redeemdetail = (pgID) => {
    history.push("/mfredeem/" + btoa(pgID));
  };
  const switchdetail = (pgID) => {
    history.push("/mfswitch/" + btoa(pgID));
  };
  const showdropdown = (dropdownid, funds) => {
    if (funds != undefined) {
      var element = document.getElementById(dropdownid);
      if (element.style.display == '') {
        element.style.display = 'none';
      } else {
        element.style.display = '';
      }
    }
  }
  const getgoalstoxholdings = () => {
    const dataString = {
    }
    setSpinnerLoading(true);
    apiServices.getgoalstoxholdingsdataPostRequest(dataString).then(res => {
      if (res.data.status == "success") {
        // console.log("aaujooo",res.data.data[0].similarfunds);
        setGoalstoxHoldingsData(res.data.data)
        setSpinnerLoading(false);
        setgoalstoxportfolio(res.data.goalstoxportfolio)
      }
      else if (res.data.status == "error" && res.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(res.data.message)
        setSpinnerLoading(false)
        return false
      }
    })
  }
  const showgoalstoxportfolio = () => {
    setportfolioshow(1);
    settotalportfolioclass('panel holding-panel phbox mg-b-15')
    setgoalstoxportfolioclass('panel holding-panel phbox active mg-b-15')
  }
  const showtotalportfolio = () => {
    setportfolioshow(0);
    settotalportfolioclass('panel holding-panel phbox active mg-b-15')
    setgoalstoxportfolioclass('panel holding-panel phbox mg-b-15')
  }
  // console.log("hlhlh",GoalstoxHoldingsData);
  return (
    <>
      <Header />
      <section className='bg-gray-light section-small'>
        <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
          <div className='overlay-box'>
            <Watch
              color="#ffffff"
              visible={spinnerLoading}
            />
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6" onClick={showtotalportfolio}>
              <div className={totalportfolioclass}>
                <div className="row">
                  <div className="col-lg-6">
                    <h6 className="mg-b-5">Total Portfolio</h6>
                    <p className="mg-b-0">₹{headerData.totalportfolio}</p>
                  </div>
                  {/* <div className="col-lg-4">
                <h6 className="mg-b-5">Last Update</h6>
              <p className="mg-b-0">{moment(headerData.totallastupdate).format('DD-MMM-YYYY')}</p>
                </div> */}
                </div>
              </div>
            </div>
            <div className="col-lg-6" onClick={showgoalstoxportfolio}>
              <div className={goalstoxportfolioclass}>
                <div className="row">
                  <div className="col-lg-6">
                    <h6 className="mg-b-5">Portfolio With Goalstox</h6>
                    <p className="mg-b-0">₹{goalstoxportfolio}</p>
                  </div>
                  {/* <div className="col-lg-4">
                <h6 className="mg-b-5">Last Update</h6>
              <p className="mg-b-0">-</p>
                </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="table-responsive">
                {(() => {
                  if (portfolioshow == 0) {
                    if (HoldingsData.length > 0) {
                      return (
                      
                        <table className="table table-bordered">
                          <tr>
                            <th>Scheme</th>
                            <th>Folio</th>
                            <th>Latest NAV</th>
                            <th>Units Held</th>
                            <th>Value at NAV</th>
                            {/* <th>Action</th> */}
                          </tr>
                          {HoldingsData.map((value) => {
                            return (
                              <>
                              {value.ic_unitholding > 0 ?
                              <tr>
                                <td>{value.ic_schemename}</td>
                                <td>{value.ic_foliono}</td>
                                <td>{value.ic_nav}</td>
                                <td>{value.ic_unitholding}</td>
                                <td>{value.ic_currentvalue}</td>
                                {/* <td>
                                  <button type="submit" style={{ padding: '0px' }} onClick={(e) => redeemdetail(value.pg_id)} className=" buttonab-line">Redeem<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button>
                                  <button type="submit" style={{ padding: '0px' }} onClick={(e) => switchdetail(value.pg_id)} className=" buttonab-line">Switch<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button>
                                </td> */}
                              </tr>:""}
                              </>
                            );
                          })}
                        </table>
                      );
                    }
                    else {
                      return (
                        <div className='col-lg-12'>
                          <div className='mfsipbox mg-b-15' style={{ paddingBottom: "0px", paddingTop: "10px" }}>
                            <div className='mfsipbox-planname'>No Previous Holdings Found !</div></div>
                        </div>
                      );
                    }
                  }
                })()}
                {(() => {
                  if (portfolioshow == 1) {
                    if (GoalstoxHoldingsData.length > 0) {
                      return (
                        <table className="table table-bordered">
                          <tr>
                            <th>Scheme</th>
                            <th>Units Held</th>
                            <th>Average Cost Price</th>
                            <th>Value At Cost</th>
                            <th>Latest NAV</th>
                            <th>Value at NAV</th>
                            <th>Unrealized P&L(Rs.)</th>
                            <th>Unrealized P&L(%)</th>
                            <th>Action</th>
                          </tr>
                          {GoalstoxHoldingsData.map((value, index) => {
                            // console.log("aaawww",value.similarfunds)
                            return (
                              <>
                            
                                <tr onClick={(e) => showdropdown('dropdown' + index, value.similarfunds)}>
                                  <td style={{ cursor: "pointer" }} className={value.similarfunds && value.similarfunds != undefined ? 'similarfundsred' : ''}>{value.pg_schemename}</td>
                                  <td>{value.totalunits}</td>
                                  <td>{value.avgcostprice}</td>
                                  <td>{value.valueatcost}</td>
                                  <td>{value.pg_nav}</td>
                                  <td>{value.valueatnav}</td>
                                  <td style={{ color: Math.sign(value.unrealisedprofit) === -1 ? "red" : "green" }} >{value.unrealisedprofit}</td>
                                  <td style={{ color: Math.sign(value.unrealisedprofitpercent) === -1 ? "red" : "green" }}>{Math.sign(value.unrealisedprofitpercent) === -1 ? <i class="fa fa-arrow-down" aria-hidden="true"></i> : <i class="fa fa-arrow-up" aria-hidden="true"></i>}{value.unrealisedprofitpercent}%</td>
                                  <td>
                                    {/* <button type="submit" style={{padding:'0px'}} onClick={purchasedetail} className=" buttonab-line">Purchase<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button>
                                    <button type="submit" style={{padding:'0px'}} onClick={sipdetail} className=" buttonab-line"> SIP<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button> */}
                                    <button type="submit" style={{ padding: '0px' }} onClick={(e) => redeemdetail(value.pg_id)} className=" buttonab-line">Redeem<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button>
                                    <button type="submit" style={{ padding: '0px' }} onClick={(e) => switchdetail(value.pg_id)} className=" buttonab-line">Switch<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button>
                                  </td>
                                </tr>
                                <tr id={'dropdown' + index} style={{ display: 'none' }}>
                                  <td colSpan={9} style={{ padding: '0px' }}>
                                    <div style={{ width: '100%' }}>
                                      <table className="table table-bordered" >
                                        <tr>
                                          <th>Trans Date</th>
                                          <th>Trans Type</th>
                                          <th>Folio Number</th>
                                          <th>NAV Values per unit</th>
                                          <th>Units</th>
                                          <th>Amount</th>
                                          <th>Remarks</th>
                                        </tr>
                                        {value.similarfunds != undefined && value.similarfunds.length > 0 && value.similarfunds.map((subvalue) => {
                                          return (
                                            <tr>
                                              <td>{subvalue.pg_trans_date}</td>
                                              <td>{subvalue.pg_trans_type}</td>
                                              <td>{subvalue.pg_folio_no}</td>
                                              <td>{subvalue.pg_pur_price}</td>
                                              <td>{subvalue.pg_unitholding}</td>
                                              {subvalue.amount && subvalue.amount == 'negative' ?
                                                <td style={{ color: "red" }}>-{Math.round(subvalue.pg_pur_price * subvalue.pg_unitholding * 100) / 100}</td>
                                                : <td style={{ color: "green" }}>{Math.round(subvalue.pg_pur_price * subvalue.pg_unitholding * 100) / 100}</td>
                                              }
                                              <td>GOALSTOX</td>
                                            </tr>
                                          )
                                        })
                                        }
                                      </table>
                                    </div>
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                        </table>
                      );
                    }
                    else {
                      return (
                        <div className='mfsipbox mg-b-15' style={{ paddingBottom: "0px", paddingTop: "10px" }}>
                          <div className='mfsipbox-planname'>No Goalstox Holdings Found !</div></div>
                      );
                    }
                  }
                })()}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}
export default Holdings;